import React, { useState } from 'react';
import './LoginPage.css';
import CommonHeader from '../components/CommonHeader';
import LoginComponent from '../components/LoginComponent';
import ForgotPassword from '../components/ForgotPassword';

const LoginPage = () => {
  const [showForgotPassword, setShowForgotPassword] = useState(false);

  return (
    <div className="login-page">
      <div className="login-nav">
        <CommonHeader />
      </div>
      <div className="login-container">
        {showForgotPassword ? (
          <ForgotPassword onBackToLogin={() => setShowForgotPassword(false)} />
        ) : (
          <LoginComponent onClickShowForgotPassword={() => setShowForgotPassword(true)} />
        )}
      </div>
    </div>
  );
};

export default LoginPage;